import { Modal } from '@mantine/core'

import Button from 'src/components/Buttons/Button/Button'

export interface UnsavedChangesModalProps {
  opened: boolean
  saving?: boolean
  onSaveAndLeave: () => void
  onDiscard: () => void
  onKeepEditing: () => void
}

const UnsavedChangesModal = ({
  opened,
  saving = false,
  onSaveAndLeave,
  onDiscard,
  onKeepEditing,
}: UnsavedChangesModalProps) => (
  <Modal
    opened={opened}
    onClose={onKeepEditing}
    centered
    withCloseButton={false}
    radius="md"
    padding="lg"
  >
    <div className="flex flex-col gap-2">
      <div className="text-lg font-semibold text-doubleNickel-gray-900">
        You have unsaved changes
      </div>
      <div className="text-sm text-doubleNickel-gray-600">
        Save them before leaving this step, or discard them to keep what was
        saved before.
      </div>
    </div>
    <div className="mt-6 flex flex-col gap-3">
      <Button
        text="Save and leave"
        onClick={onSaveAndLeave}
        loading={saving}
        className="h-11 w-full rounded-lg text-sm font-semibold"
      />
      <Button
        text="Keep editing"
        onClick={onKeepEditing}
        variant="outline"
        className="h-11 w-full rounded-lg text-sm font-semibold"
      />
      <Button
        text="Discard changes"
        onClick={onDiscard}
        variant="subtle"
        className="h-11 w-full rounded-lg text-sm font-semibold text-doubleNickel-error-600"
      />
    </div>
  </Modal>
)

export default UnsavedChangesModal
